import BeatLoader from 'react-spinners/BeatLoader';

import { getDomain } from '../../utils/functions';

const Spinner = () => {
  const domain = getDomain();
  const color = domain === 'pyha' ? '#2a2e4b' : '#ff1706';

  return (
    <div className='spinner flex justify-center'>
      <BeatLoader color={color} />
    </div>
  );
};

export default Spinner;
